import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { remarkAlerts } from './markdown/alerts';
import { remarkHeadingIds } from './markdown/headingIds';
import { buildComponents } from './markdown/components';
import { helpLinkUri } from './markdown/linkUri';

interface GuideRendererProps {
  markdown: string;
  onNavigateGuide: (id: string) => void;
}

export const GuideRenderer: React.FC<GuideRendererProps> = ({
  markdown,
  onNavigateGuide,
}) => {
  const components = useMemo(
    () => buildComponents({ onNavigateGuide }),
    [onNavigateGuide]
  );
  return (
    <article className="help-guide min-w-0 max-w-none break-words">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkAlerts, remarkHeadingIds]}
        transformLinkUri={helpLinkUri}
        skipHtml
        components={components}
      >
        {markdown}
      </ReactMarkdown>
    </article>
  );
};
